import { Pipe, PipeTransform } from '@angular/core';
import { QuestionnaireRequest } from 'src/API';
import { isConsentQuestionnaire } from 'src/app/core/api/consent-form.util';

@Pipe({
  name: 'isConsentQuestionnaire'
})
export class IsConsentQuestionnairePipe implements PipeTransform {
  transform(questionnaire: QuestionnaireRequest): boolean {
    return isConsentQuestionnaire(questionnaire);
  }
}
